(() => {
  const nutritionCache = new Map();

  function cleanProductInfo(source) {
    const copy = source.cloneNode(true);
    copy.querySelectorAll('img,picture,source,script,style').forEach(element => element.remove());
    copy.querySelectorAll('*').forEach(element => {
      [...element.attributes].forEach(attribute => { if (/^on/i.test(attribute.name)) element.removeAttribute(attribute.name); });
    });
    copy.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href') || '';
      if (/^javascript:/i.test(href)) link.removeAttribute('href');
      if (/\.(?:png|jpe?g|webp|gif)(?:\?|$)/i.test(href) || /tabela original|ampliar tabela/i.test(link.textContent || '')) {
        const paragraph = link.closest('p');
        (paragraph || link).remove();
      }
    });
    copy.querySelectorAll('details[name]').forEach(details => details.removeAttribute('name'));
    copy.querySelectorAll('.hs-product-essentials > details').forEach(details => {
      details.open = !!details.querySelector('.hs-label-nutrition, .hs-native-nutrition');
    });
    return copy.outerHTML;
  }

  async function getProductInfo(url) {
    if (!nutritionCache.has(url)) {
      nutritionCache.set(url, (async () => {
        const response = await fetch(url, { headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Não foi possível carregar estas informações.');
        const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = documentCopy.querySelector('#MainContent .hs-kit-details') || documentCopy.querySelector('#MainContent .hs-product-essentials');
        if (!source) throw new Error('Estas informações ainda não estão disponíveis para este produto.');
        return cleanProductInfo(source);
      })());
    }
    return nutritionCache.get(url);
  }

  function initKitNutrition(content) {
    const kit = content.querySelector('.hs-kit-details');
    if (!kit) return;
    const tabs = [...kit.querySelectorAll('[data-kit-tab]')];
    const panels = [...kit.querySelectorAll('[data-kit-panel]')];
    const originalNav = kit.querySelector('.hs-kit-flavors');
    if (!tabs.length || tabs.length !== panels.length || !originalNav) return;
    originalNav.hidden = true;
    const toolbar = document.createElement('nav');
    toolbar.className = 'hc-nutrition-kit-nav';
    toolbar.setAttribute('aria-label', 'Navegar pelos sabores do kit');
    toolbar.innerHTML = '<button type="button" data-hc-kit-prev aria-label="Sabor anterior">←</button><div><strong data-hc-kit-title></strong><span data-hc-kit-count aria-live="polite"></span></div><button type="button" data-hc-kit-next aria-label="Próximo sabor">→</button>';
    originalNav.before(toolbar);
    let active = 0;
    const select = index => {
      active = (index + panels.length) % panels.length;
      panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== active; });
      toolbar.querySelector('[data-hc-kit-title]').textContent = tabs[active].textContent.trim();
      toolbar.querySelector('[data-hc-kit-count]').textContent = `${active + 1} de ${panels.length}`;
      content.scrollTop = 0;
    };
    toolbar.querySelector('[data-hc-kit-prev]').addEventListener('click', () => select(active - 1));
    toolbar.querySelector('[data-hc-kit-next]').addEventListener('click', () => select(active + 1));
    select(0);
  }

  async function loadNutrition(modal) {
    if (modal.dataset.loaded === 'true' || modal.dataset.loading === 'true') return;
    modal.dataset.loading = 'true';
    const content = modal.querySelector('[data-hc-nutrition-content]');
    try {
      const html = await getProductInfo(modal.dataset.hcProductUrl);
      content.innerHTML = html;
      initKitNutrition(content);
      modal.dataset.loaded = 'true';
    } catch (error) {
      const message = document.createElement('p');
      message.className = 'hc-nutrition-error';
      message.setAttribute('role', 'status');
      message.textContent = error.message || 'Não foi possível carregar estas informações.';
      content.replaceChildren(message);
      nutritionCache.delete(modal.dataset.hcProductUrl);
    } finally {
      delete modal.dataset.loading;
    }
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const motion = 'smooth';
    // Keep the kit disclosures in each visible card row in sync.
    root.addEventListener('click', event => {
      const summary = event.target.closest('.hc-card--kit .hc-kit-details > summary');
      if (!summary || !root.contains(summary)) return;
      const details = summary.parentElement;
      const card = summary.closest('.hc-card--kit');
      const row = card.closest('.swiper-wrapper, [data-hc-track], .hc-grid') || root;
      const rowTop = card.getBoundingClientRect().top;
      requestAnimationFrame(() => {
        if (!card.isConnected) return;
        row.querySelectorAll('.hc-card--kit .hc-kit-details').forEach(peer => {
          const peerCard = peer.closest('.hc-card--kit');
          if (peerCard && Math.abs(peerCard.getBoundingClientRect().top - rowTop) < 4) {
            peer.open = details.open;
          }
        });
      });
    });
    const toggle = root.querySelector('[data-hc-filter-toggle]');
    const filters = root.querySelector('.hc-filters');
    if (toggle && filters) toggle.addEventListener('click', () => { filters.hidden = !filters.hidden; toggle.setAttribute('aria-expanded', String(!filters.hidden)); });
    root.querySelectorAll('[data-hc-shelf]').forEach(shelf => {
      const track = shelf.querySelector('[data-hc-track]');
      const prev = shelf.querySelector('[data-hc-direction="-1"]');
      const next = shelf.querySelector('[data-hc-direction="1"]');
      const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      shelf.querySelectorAll('[data-hc-direction]').forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('[data-hc-card]');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({ left: step * Number(button.dataset.hcDirection), behavior: motion });
      }));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-hc-banner]').forEach(banner => {
      const track = banner.querySelector('[data-hc-track]');
      const dots = [...banner.querySelectorAll('[data-hc-slide]')];
      dots.forEach((dot, index) => dot.addEventListener('click', () => track.scrollTo({ left: index * track.clientWidth, behavior: motion })));
      track.addEventListener('scroll', () => { const index = Math.round(track.scrollLeft / track.clientWidth); dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index))); }, { passive: true });
    });
    root.querySelectorAll('[data-hc-add]').forEach(form => {
      const quantity = form.elements.quantity;
      const normalize = () => { quantity.value = Math.min(99, Math.max(1, parseInt(quantity.value, 10) || 1)); };
      quantity.addEventListener('change', normalize);
      form.querySelectorAll('[data-hc-step]').forEach(button => button.addEventListener('click', () => { normalize(); quantity.value = Number(quantity.value) + Number(button.dataset.hcStep); normalize(); }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        if (button.disabled) return;
        normalize();
        const status = form.closest('[data-hc-card]').querySelector('.hc-card-status');
        const label = button.innerHTML;
        button.disabled = true; button.textContent = 'Adicionando…';
        status.textContent = ''; status.classList.remove('is-error');
        const shopRoot = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: Number(quantity.value) }] }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Não foi possível adicionar. Tente novamente.');
          status.textContent = 'Adicionado ao carrinho!';
          window.dispatchEvent(new CustomEvent('cart-change', { bubbles: true }));
          const store = window.Alpine?.store('cart');
          if (typeof store?.fetchItems === 'function') store.fetchItems();
        } catch (error) {
          status.textContent = error.message || 'Confira sua conexão e tente novamente.';
          status.classList.add('is-error');
        } finally { button.disabled = false; button.innerHTML = label; }
      });
    });
    let nutritionTrigger = null;
    const closeNutrition = modal => {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('hc-nutrition-open');
      if (nutritionTrigger?.isConnected) nutritionTrigger.focus();
      nutritionTrigger = null;
    };
    root.addEventListener('click', event => {
      const open = event.target.closest('[data-hc-nutrition-open]');
      if (open && root.contains(open)) {
        const card = open.closest('[data-hc-card]');
        const modal = open._hcNutritionModal || card?.querySelector('[data-hc-nutrition-modal]');
        if (!modal) return;
        open._hcNutritionModal = modal;
        nutritionTrigger = open;
        if (modal.parentElement !== document.body) document.body.appendChild(modal);
        if (modal.dataset.hcPortalReady !== 'true') {
          modal.querySelectorAll('[data-hc-nutrition-close]').forEach(close => close.addEventListener('click', () => closeNutrition(modal)));
          modal.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              closeNutrition(modal);
              return;
            }
            if (event.key === 'Tab') {
              const focusable = [...modal.querySelectorAll('button,a[href],summary,[tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length);
              if (!focusable.length) return;
              const first = focusable[0];
              const last = focusable[focusable.length - 1];
              if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
              if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
            }
          });
          modal.dataset.hcPortalReady = 'true';
        }
        modal.hidden = false;
    modal.querySelectorAll('.hs-product-essentials > details').forEach(details => { details.open = !!details.querySelector('.hs-label-nutrition, .hs-native-nutrition'); });
        document.documentElement.classList.add('hc-nutrition-open');
        modal.querySelector('[data-hc-nutrition-close]:not([tabindex="-1"])')?.focus();
        loadNutrition(modal);
        return;
      }
      const close = event.target.closest('[data-hc-nutrition-close]');
      if (close && root.contains(close)) closeNutrition(close.closest('[data-hc-nutrition-modal]'));
    });
    root.addEventListener('keydown', event => {
      const modal = root.querySelector('[data-hc-nutrition-modal]:not([hidden])');
      if (!modal) return;
      if (event.key === 'Escape') {
        closeNutrition(modal);
        return;
      }
      if (event.key === 'Tab') {
        const focusable = [...modal.querySelectorAll('button,a[href],summary,[tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  }
  document.querySelectorAll('[data-hc-collection]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hc-collection]').forEach(init));
})();

/* Reuse the structured nutrition modal on the legacy home product cards. */
(() => {
  const cache = new Map();
  let trigger = null;

  function cleanProductInfo(source) {
    const copy = source.cloneNode(true);
    copy.querySelectorAll('img,picture,source,script,style').forEach(element => element.remove());
    copy.querySelectorAll('*').forEach(element => {
      [...element.attributes].forEach(attribute => {
        if (/^on/i.test(attribute.name)) element.removeAttribute(attribute.name);
      });
    });
    copy.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href') || '';
      if (/^javascript:/i.test(href)) link.removeAttribute('href');
      if (/\.(?:png|jpe?g|webp|gif)(?:\?|$)/i.test(href) || /tabela original|ampliar tabela/i.test(link.textContent || '')) {
        (link.closest('p') || link).remove();
      }
    });
    copy.querySelectorAll('details[name]').forEach(details => details.removeAttribute('name'));
    copy.querySelectorAll('.hs-product-essentials > details').forEach(details => {
      details.open = !!details.querySelector('.hs-label-nutrition, .hs-native-nutrition');
    });
    return copy.outerHTML;
  }

  async function getProductInfo(url) {
    if (!cache.has(url)) {
      cache.set(url, (async () => {
        const response = await fetch(url, {
          headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Não foi possível carregar estas informações.');
        const productDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = productDocument.querySelector('#MainContent .hs-product-essentials') || productDocument.querySelector('#MainContent .hs-kit-details');
        if (!source) throw new Error('Estas informações ainda não estão disponíveis para este produto.');
        return cleanProductInfo(source);
      })());
    }
    return cache.get(url);
  }

  function close(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('hc-nutrition-open');
    if (trigger?.isConnected) trigger.focus();
    trigger = null;
  }

  function keepFocus(modal, event) {
    if (event.key === 'Escape') {
      close(modal);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...modal.querySelectorAll('button,a[href],summary,[tabindex]:not([tabindex="-1"])')]
      .filter(element => element.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function prepare(button, modal) {
    if (modal.dataset.hcLegacyReady === 'true') return modal;
    const card = button.closest('.product-card-item');
    const productLink = modal.querySelector('.hs-unit-nutrition-note a') || card?.querySelector('.product-title');
    const productUrl = productLink?.getAttribute('href') || '';
    const productTitle = card?.querySelector('.product-title')?.textContent?.trim()
      || button.getAttribute('aria-label')?.replace(/^.*? de /, '')
      || 'Produto';

    modal.removeAttribute('onclick');
    modal.className = 'hc-nutrition-modal';
    modal.dataset.hcProductUrl = productUrl;
    modal.dataset.hcLegacyReady = 'true';
    modal.hidden = true;
    modal.innerHTML = '<button class="hc-nutrition-backdrop" type="button" data-hc-legacy-close tabindex="-1" aria-label="Fechar tabela nutricional"></button>'
      + '<div class="hc-nutrition-panel" role="document">'
      + '<button class="hc-nutrition-close" type="button" data-hc-legacy-close aria-label="Fechar tabela nutricional">×</button>'
      + '<header class="hc-nutrition-heading"><span>Informações do produto</span><h2></h2></header>'
      + '<div class="hc-nutrition-content" data-hc-legacy-content tabindex="0"><p class="hc-nutrition-loading" role="status">Carregando tabela, ingredientes e alergênicos…</p></div>'
      + '<a class="hc-nutrition-product-link">Ver página completa do produto →</a>'
      + '</div>';
    modal.querySelector('.hc-nutrition-heading h2').textContent = productTitle;
    const fullLink = modal.querySelector('.hc-nutrition-product-link');
    fullLink.href = productUrl;
    modal.querySelectorAll('[data-hc-legacy-close]').forEach(control => control.addEventListener('click', () => close(modal)));
    modal.addEventListener('keydown', event => keepFocus(modal, event));
    document.body.appendChild(modal);
    return modal;
  }

  async function open(button, modal) {
    trigger = button;
    prepare(button, modal);
    modal.hidden = false;
    modal.querySelectorAll('.hs-product-essentials > details').forEach(details => { details.open = !!details.querySelector('.hs-label-nutrition, .hs-native-nutrition'); });
    document.documentElement.classList.add('hc-nutrition-open');
    modal.querySelector('[data-hc-legacy-close]:not([tabindex="-1"])')?.focus();
    if (modal.dataset.loaded === 'true' || modal.dataset.loading === 'true') return;
    modal.dataset.loading = 'true';
    const content = modal.querySelector('[data-hc-legacy-content]');
    try {
      content.innerHTML = await getProductInfo(modal.dataset.hcProductUrl);
      modal.dataset.loaded = 'true';
    } catch (error) {
      const message = document.createElement('p');
      message.className = 'hc-nutrition-error';
      message.setAttribute('role', 'status');
      message.textContent = error.message || 'Não foi possível carregar estas informações.';
      content.replaceChildren(message);
      cache.delete(modal.dataset.hcProductUrl);
    } finally {
      delete modal.dataset.loading;
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.hs-unit-nutrition-button');
    if (!button) return;
    const match = (button.getAttribute('onclick') || '').match(/openModal\(['"]([^'"]+)['"]\)/);
    const modal = match ? document.getElementById(match[1]) : null;
    if (!modal) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(button, modal);
  }, true);
})();